import { useState } from "react";
import { useCreateProductServiceAdminAxiosInstance } from "../../Auth/useCreateProductServiceAdminAxiosInstance.ts";
import {
  BonificoOrderDTO,
  ConfirmBonificoOrderPayload,
  CreateB2BBonificoOrderPayload,
  CreateExternalSettlementPayload,
  CreateHistoricalBonificoOrderPayload,
} from "./BonificoOrderDTO.ts";

export function useCreateBonificoOrder() {
  const { createAxiosInstance } = useCreateProductServiceAdminAxiosInstance();
  const [loading, setLoading] = useState(false);

  const post = async (url: string, payload: object) => {
    setLoading(true);
    try {
      const { data } = await createAxiosInstance().post<BonificoOrderDTO>(
        url,
        payload,
      );
      return data;
    } finally {
      setLoading(false);
    }
  };

  const createConfirmedOrder = (payload: ConfirmBonificoOrderPayload) =>
    post("/bonifico-orders", payload);

  const confirmDraft = (
    orderId: string,
    payload: ConfirmBonificoOrderPayload,
  ) => post(`/bonifico-orders/${orderId}/confirm`, payload);

  const createHistoricalOrder = (
    payload: CreateHistoricalBonificoOrderPayload,
  ) => post("/bonifico-orders/historical", payload);

  const createB2BOrder = (payload: CreateB2BBonificoOrderPayload) =>
    post("/bonifico-orders/b2b", payload);

  const createExternalSettlement = (payload: CreateExternalSettlementPayload) =>
    post("/bonifico-orders/external-settlements", payload);

  const confirmDraftAsExternalSettlement = (
    orderId: string,
    payload: CreateExternalSettlementPayload,
  ) =>
    post(`/bonifico-orders/${orderId}/confirm-as-external-settlement`, payload);

  return {
    createConfirmedOrder,
    confirmDraft,
    createHistoricalOrder,
    createB2BOrder,
    createExternalSettlement,
    confirmDraftAsExternalSettlement,
    loading,
  };
}
